import { render } from "./createCostDialog.vue?vue&type=template&id=59be06e9&scoped=true"
import script from "./createCostDialog.vue?vue&type=script&lang=js"
export * from "./createCostDialog.vue?vue&type=script&lang=js"

import "./createCostDialog.vue?vue&type=style&index=0&id=59be06e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59be06e9"]])

export default __exports__